// extracted by mini-css-extract-plugin
module.exports = {"list":"list-Yus9emsM","current":"current-2zJQjcKG"};